
import { Vue, Component, Prop } from 'nuxt-property-decorator';
import BaseCeImage from 'nuxt-typo3/lib/templates/components/content/elements/CeImage';
import type { PropType } from 'vue';
import MediaGallery from './MediaGallery.vue';
import { ElementMetaData, ImageMetaData } from '@/types/contentContract';
import { ColPosAppearance, Gallery } from '@/types/pageContract';
import MetaDataForContentSecond from '@/components/typo3-library-overrides/media/MetaDataForContentSecond.vue';
import MetaDataForContentFirst from '@/components/typo3-library-overrides/media/MetaDataForContentFirst.vue';

@Component({
  components: {
    MetaDataForContentFirst,
    MetaDataForContentSecond,
    MediaGallery
  },
  extends: BaseCeImage
})
export default class CeImage extends Vue implements BaseCeImage {
  @Prop({ type: Object as PropType<ColPosAppearance>, default: () => {} })
  appearance!: ColPosAppearance;

  @Prop({ type: Object as PropType<ImageMetaData>, default: () => {} })
  imageMetaData: ImageMetaData;

  // TODO: if there are no elementMetaData, we should maybe not return an empty array, as the original type is an object? (MJO)
  @Prop({
    type: [Object, Array],
    default: () => {}
  })
  elementMetaData!: ElementMetaData;

  gallery: Gallery;

  get isCarousel(): boolean {
    return Boolean(this.$attrs.carousel);
  }

  get hasElementMetaData(): boolean {
    return Object.keys(this.elementMetaData).some((key) => {
      return this.elementMetaData[key] && this.elementMetaData[key] !== '';
    });
  }

  get metadataIsArray(): boolean {
    return this.elementMetaData instanceof Array;
  }

  get hasImageMetaData(): boolean {
    return (
      this.imageMetaData.imagecaption !== '' ||
      this.imageMetaData.medialabels !== ''
    );
  }
}
